import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Flame, Snowflake, X } from 'lucide-react';
import { useMeteoConseil } from '../hooks/useMeteoConseil';

// Site-wide Météo-Conseil banner — appears at the very top of Accueil, Prestations, Devis.
// Only the high-priority temperature alerts (Canicule / Gel) render here.
// Wind & water tips live inside the weather widget.
const ALLOWED_PATHS = ['/', '/services', '/devis'];

const MeteoConseilBanner = () => {
  const location = useLocation();
  const { conseil } = useMeteoConseil();
  const [dismissed, setDismissed] = useState(false);

  if (!ALLOWED_PATHS.includes(location.pathname)) return null;
  if (!conseil || dismissed) return null;

  const { alerts } = conseil;
  if (!alerts.canicule && !alerts.gel) return null;

  // Canicule takes visual priority over Gel (they are mutually exclusive by threshold anyway)
  const isCanicule = alerts.canicule;

  const config = isCanicule
    ? {
        wrapper: 'bg-amber-100 border-b border-amber-300 text-amber-900',
        icon: <Flame size={18} className="text-amber-600 shrink-0" />,
        message:
          '⚠️ Alerte Chaleur : Pour préserver votre pelouse (risques de brûlure), je décale mes interventions de tonte. Je reste joignable sur WhatsApp.',
        testid: 'meteo-banner-canicule',
      }
    : {
        wrapper: 'bg-blue-100 border-b border-blue-300 text-blue-900',
        icon: <Snowflake size={18} className="text-blue-600 shrink-0" />,
        message:
          '❄️ Alerte Gel : Attention aux plantes fragiles et aux robinets extérieurs. Contactez-moi pour une mise en hivernage (Vigilance SAP).',
        testid: 'meteo-banner-gel',
      };

  return (
    <div className={config.wrapper} data-testid={config.testid} role="alert">
      <div className="max-w-7xl mx-auto px-4 py-2.5 flex items-center gap-3">
        {config.icon}
        <p className="text-sm font-medium leading-snug flex-1">{config.message}</p>
        <button
          onClick={() => setDismissed(true)}
          aria-label="Fermer l'alerte météo"
          data-testid="meteo-banner-close"
          className="shrink-0 opacity-70 hover:opacity-100 transition-opacity"
        >
          <X size={18} />
        </button>
      </div>
    </div>
  );
};

export default MeteoConseilBanner;
